export default __webpack_public_path__ + "static/media/visit_now.5358d9f0.gif";